import { html } from "lit";
import type { TemplateResult } from "lit";

const icon = (d: string, vb = "0 0 512 512") =>
  html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="${vb}"
      fill="currentColor"
      style="width:1em;height:1em;vertical-align:-0.125em"
    >
      <path d="${d}" />
    </svg>
  `;

export const faCamera = icon(
  "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z",
);

export const faDownload = icon(
  "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z",
);

export const faEllipsisV = icon(
  "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z",
  "0 0 192 512",
);

export const faFile = icon(
  "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1V144H246.6L384 6.5v115.4zM0 0h1v1H0z",
  "0 0 384 512",
);

export const faHistory = icon(
  "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z",
);

export const faImage = icon(
  "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z",
);

export const faMapMarkerAlt = icon(
  "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
  "0 0 384 512",
);

export const faMicrophone = icon(
  "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z",
  "0 0 352 512",
);

export const faMicrophoneSlash = icon(
  "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.64-3.29 34.47-9.56 49.99L391.44 267.77C392.48 263.95 400 225.42 400 176V96c0-70.7-57.3-128-128-128-61.67 0-113.09 43.66-125.07 101.77L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM352 364.15V464h-56v33.77c87.78-12.22 151.88-82.72 159.42-168.34L402.54 288c-5.88 30.64-22.81 57.68-50.54 76.15zM176 211.56V96c0-44.18 35.82-80 80-80 38.04 0 69.78 26.66 77.85 62.37L176 211.56zm80 237.44c-44.18 0-80-35.82-80-80v-15.59L67.03 269.34C59.4 285.97 48 320.19 48 343.87V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v135.87C0 432.42 63.97 512.33 152 524.64V464H96c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v16c0 8.84-7.16 16-16 16h-56v60.64c3.62-.5 7.11-1.4 10.69-2.02L256 497.09V449c-62.1 0-94.24-2.06-96-5.07V369l-14.52-11.23C146.67 398.37 200.6 449 256 449z",
  "0 0 640 512",
);

export const faPaperclip = icon(
  "M43.246 466.142c-58.43-60.289-56.378-157.153 4.502-216.052L209.18 91.927c41.686-41.278 109.23-41.012 150.575.794 40.528 40.968 40.175 107.31-.794 148.26L212.95 385.764c-28.393 28.142-73.942 27.842-101.979-.755-27.3-27.843-27.552-72.625.283-100.426l130.25-129.258c5.3-5.268 13.828-5.234 19.097.068l18.76 18.97c5.266 5.3 5.234 13.826-.068 19.096L149.04 322.715c-6.668 6.617-6.73 17.399-.14 24.073 6.628 6.71 17.5 6.773 24.164.138l146.012-144.783c20.003-19.845 20.227-52.258.5-72.345-19.906-20.272-52.576-20.52-72.718-.422L88.425 287.54c-38.252 37.922-38.74 99.959-1.003 138.369 37.9 38.575 100.44 39.128 139.11.81L408.59 248.396c5.276-5.233 13.8-5.195 19.036.08l18.796 18.958c5.236 5.275 5.198 13.8-.08 19.035L264.287 464.793c-60.112 59.594-156.626 61.674-221.041 1.349z",
  "0 0 448 512",
);

export const faPaperPlane = icon(
  "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z",
);

export const faPause = icon(
  "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z",
  "0 0 448 512",
);

export const faPen = icon(
  "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z",
);

export const faPhoneAlt = icon(
  "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z",
);

export const faPlay = icon(
  "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z",
  "0 0 448 512",
);

export const faStop = icon(
  "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z",
  "0 0 448 512",
);

export const faVideoSlash = icon(
  "M633.8 458.1L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM624 167.78V344.22c0 24.02-14.74 38.36-27.56 28.21L512 306.68V432c0 26.51-21.49 48-48 48H174.15l-48.47-37.54V167.78l16.39 12.68V128c0-26.51 21.49-48 48-48h272c26.51 0 48 21.49 48 48v34.56l84.44-65.37C607.26 87.44 624 101.89 624 125.78v42z",
  "0 0 640 512",
);

export const faSmile = icon(
  "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.4-118.7c-5.7-8.8-17.3-11.3-26.1-5.6-25.5 16.4-56.5 25.1-88.4 24.8-30.5-.3-60-9.4-84.5-25.8-8.7-5.8-20.3-3.5-26.1 5.2s-3.5 20.3 5.2 26.1c31.4 21 68.2 32.3 106.5 32.7 40.3.4 79.6-11 111.8-31.3 8.8-5.6 11.3-17.3 5.6-26.1zM192 272c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z",
);

export const faCopy = icon(
  "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z",
  "0 0 448 512",
);

export const faReply = icon(
  "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 5.618 288 66.816 288 207.931 0 56.548-36.256 112.589-76.437 141.821-12.73 9.261-30.669-2.577-25.536-17.832C449.428 344.102 376.389 292.009 224 288.063v84.421c0 20.7-24.3 31.453-39.687 18.164L8.309 238.477c-11.078-9.592-11.078-26.049 0-35.641z",
  "0 0 512 512",
);

export const faShare = icon(
  "M503.7 226.2l-160-160c-21.9-21.9-59.7-6.3-59.7 24.7V160H224C100.3 160 0 260.3 0 384c0 35.3 28.7 64 64 64 27.2 0 50.4-16.9 59.8-41.4 24.4-63.7 85.3-110.6 156.2-110.6h5v69.1c0 31.1 37.8 46.6 59.7 24.7l160-160c12.5-12.5 12.5-32.8 0-45.6z",
  "0 0 512 512",
);

export const faChevronDown = icon(
  "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
  "0 0 24 24",
);

export type IconFn = () => TemplateResult;
